module.exports = __webpack_public_path__ + "static/media/text.4abea676.svg";